// Resource-planning AI assistant. Reuses the existing /api/analyzeTeam backend
// (Anthropic key stays server-side) with a staffing-focused prompt.

const SYSTEM = `You are a construction resource-planning assistant for Hardaway, a general contractor. You understand the Culture Index behavioral framework and how it maps to construction roles:

- A (Autonomy): high = assertive leader/driver; low = cooperative supporter.
- B (Social): high = communicator/relationship-driven; low = analytical, works heads-down.
- C (Pace): high = methodical, steady, single-focus (great for superintendents holding a long job); low = fast, urgent, multi-tasking (great for a PM driving pace).
- D (Conformity): high = detail/quality/safety/process; low = conceptual, delegates details.
- EU = stamina, L = logic vs emotion, I = ingenuity.

Construction fit guidance: PMs want high A + low-ish C (drive) with enough D to track details; Superintendents want high C + high D (steady, quality, safety); the PM/Super pairing is the core relationship. PEs/FEs are entry-level engineers supporting the team. Avoid two high-A people fighting for control; make sure a team has quality control (D) and a communicator (B).

Your job: given the AVAILABLE BENCH and any OPEN NEEDS, recommend WHO to staff. Rank specific people by name, each with a one-line, concrete rationale grounded in their traits and role. If nobody fits well, say so plainly and describe the ideal profile to hire. Be direct and practical for construction executives — no buzzwords. Keep it concise.`;

function profileLine(p) {
  return `- ${p.FullName} — ${p.CompanyRole}${p.Archetype ? ` (${p.Archetype})` : ""}; capacity ~${p.capacity}%: A=${p.Survey_A} B=${p.Survey_B} C=${p.Survey_C} D=${p.Survey_D} EU=${p.Survey_EU} L=${p.Survey_L} I=${p.Survey_I}`;
}

// token = the MSAL id_token (useData().getToken()); the backend requires sign-in.
export async function askResourceBot({ question, bench = [], openNeeds = [], token }) {
  const benchText = bench.length ? bench.map(profileLine).join("\n") : "Nobody is currently available on the bench.";
  const needsText = openNeeds.length
    ? openNeeds.map((n) => `- ${n.jobName}${n.buildingType ? ` (${n.buildingType})` : ""}${n.confidence != null ? ` — ${n.confidence}% win confidence` : ""}`).join("\n")
    : "None specified.";

  const prompt = `AVAILABLE BENCH (people with open capacity):
${benchText}

OPEN / PIPELINE JOBS:
${needsText}

QUESTION FROM THE USER:
${question}

Answer the question. When recommending people, pull only from the AVAILABLE BENCH above, rank your picks, and give a one-line trait-based rationale for each. If the bench can't cover the need, say which profile to recruit.`;

  const res = await fetch("/api/analyzeTeam", {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(token ? { "X-Delphi-Token": token } : {}) },
    body: JSON.stringify({ system: SYSTEM, prompt, max_tokens: 1200 }),
  });
  if (!res.ok) {
    let msg = `Request failed (${res.status}).`;
    try { const e = await res.json(); if (e.error) msg = e.error; } catch {}
    throw new Error(msg);
  }
  const data = await res.json();
  return data.text || "";
}
